function refreshCart(cart) {
  var currencies = {
    AUD: "$",
    EUR: "€",
    CAD: "$",
    CZK: "Kč",
    DKK: "kr.",
    HKD: "$",
    ILS: "NIS",
    JPY: "¥",
    MYR: "RM",
    NZD: "$",
    PLN: "zł",
    SGD: "$",
    KRM: "₩",
    SEK: "kr",
    CHF: "CHF",
    AED: "Dhs.",
    USD: "$",
    GBP: "£",
  };
  var locales = {
    AUD: "en-AU",
    EUR: "en-AT",
    CAD: "en-CA",
    CZK: "en-CZ",
    DKK: "en-DK",
    NZD: "en-NZ",
    PLN: "en-PL",
    CHF: "en-CH",
    USD: "en-US",
    GBP: "en-GB",
  };
  currency = currencies[cart.currency];
  local = locales[cart.currency];

  $("klarna-placement").attr("data-locale", local);

  if (cart.item_count > 0) {
    $cartContainer.classList.remove("empty__cart");
    $cartIcon.classList.remove("empty__cart");
    var items = "";
    var original_total_price = 0;
    var bundle_products = {
      "boxer-briefs": 0,
      "boxer-briefs-underwear-multipacks-europe": 0,
      briefs: 0,
      trunks: 0,
      "trunks-europe": 0,
    };
    cart.items.forEach((item) => {
      if (item.original_line_price != item.final_line_price) {
        bundle_products[item.handle] += item.quantity;
      }
    });
    cart.items.forEach((item, index) => {
      var item_url = item.url;
      var itemPrice = `<span class="price price--end">${formatCurrency(
        item.original_line_price
      )}</span>`;

      var sixpack_save = boxer_sixsave;
      var ninepack_save = boxer_ninesave;
      if (
        item.handle == "trunks" ||
        item.handle == "trunks-dark-blue-exclusives" ||
        item.handle == "trunks-europe"
      ) {
        sixpack_save = trunks_sixsave;
        ninepack_save = trunks_ninesave;
      }
      if (item.handle == "briefs") {
        sixpack_save = briefs_sixsave;
        ninepack_save = briefs_ninesave;
      }

      if (item.original_line_price != item.final_line_price) {
        var original_line_price = item.original_line_price;
        if (
          item.handle == "boxer-briefs" ||
          item.handle == "boxer-briefs-underwear-multipacks-europe" ||
          item.handle == "briefs" ||
          item.handle == "trunks" ||
          item.handle == "trunks-europe"
        ) {
          if (bundle_products[item.handle] == 2) {
            original_line_price = item.final_line_price / sixpack_save;
          }
          if (bundle_products[item.handle] > 2) {
            original_line_price = item.final_line_price / ninepack_save;
          }
        }
        itemPrice = `
                  <dl class="cart-item__discounted-prices">
                      <dd>
                          <s class="cart-item__old-price price price--end">${formatCurrency(
                            original_line_price
                          )}</s>
                      </dd>
                      <dd class="price price--end text-red">${formatCurrency(
                        item.final_line_price
                      )}</dd>
                  </dl>
              `;
        original_total_price += original_line_price;
      } else {
        var original_line_price = item.original_line_price;
        if (item.properties) {
          if (item.properties["_single_price"]) {
            if (
              item.handle == "boxer-briefs" ||
              item.handle == "boxer-briefs-underwear-multipacks-europe" ||
              item.handle == "trunks" ||
              item.handle == "trunks-europe"
            ) {
              /* original_line_price = item.properties['_single_price'] * 3 * item.quantity;
                           itemPrice = `
                               <dl class="cart-item__discounted-prices">
                                   <dd>
                                       <s class="cart-item__old-price price price--end">${formatCurrency(original_line_price)}</s>
                                   </dd>
                                   <dd class="price price--end text-red">${formatCurrency(item.final_line_price)}</dd>
                               </dl>
                           `;*/
            }
            if (
              item.handle == "duo-pack-yellow-red" ||
              item.handle == "limited-collection-duo-pack-europe" ||
              item.handle == "trunks-duo-pack" ||
              item.handle == "trunks-duo-pack-europe"
            ) {
              /*  original_line_price = item.properties['_single_price'] * 2 * item.quantity;
                            itemPrice = `
                                <dl class="cart-item__discounted-prices">
                                    <dd>
                                        <s class="cart-item__old-price price price--end">${formatCurrency(original_line_price)}</s>
                                    </dd>
                                    <dd class="price price--end text-red">${formatCurrency(item.final_line_price)}</dd>
                                </dl>
                            `;*/
            }
          }
        }
        //original_total_price += original_line_price;
      }
      if (
        item.handle == "duo-pack-yellow-red" ||
        item.handle == "limited-collection-duo-pack-europe" ||
        item.handle == "trunks-duo-pack" ||
        item.handle == "trunks-duo-pack-europe"
      ) {
        item_url = item_url.replace("?variant", "?pack=2&variant");
      } else if (
        item.handle == "boxer-briefs" ||
        item.handle == "boxer-briefs-underwear-multipacks-europe" ||
        item.handle == "trunks" ||
        item.handle == "trunks-europe"
      ) {
        item_url = item_url.replace("?variant", "?pack=3&variant");
      }

      items += `
              <div class="cart-item">

                  <a class="cart-item__image" href="${item_url}">
                      <img src="${item.image
                        .replace(/(\.[^.]*)$/, "_compact$1")
                        .replace("http:", "")}" alt="${item.title}" />
                  </a>
                  <div class="cart-item__details product-form-js">
                      <p class="cart-item__title">${item.product_title}</p>
                      <p class="cart-item__options">${item.variant_title}</p>
                      <div class="cart-item__form">
                          <div class="cart-item__price large-up-hide medium-hide">
                              ${itemPrice}
                          </div>
                          <div class="cart-item__quantity" data-id="${
                            item.id
                          }" data-line="${index + 1}" data-qty="${
        item.quantity
      }" data-properties="${JSON.stringify(item.properties)}">
                              <div class="cart-item__quantity-button minus">
                                  <span>-</span>
                              </div>
                              <div class="cart-item__remove">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove">
                                      <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                                      <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
                                  </svg>
                              </div>
                              <div class="cart-item__quantity-input">
                                  <input class="quantity__input" type="number" value="${
                                    item.quantity
                                  }">
                              </div>
                              <div class="cart-item__quantity-button plus">
                                  <span>+</span>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="cart-item__price small-hide">
                      ${itemPrice}
                  </div>
              </div>
          `;
    });
    $cartItems.innerHTML = items;

    $(".custom-cart-drawer--header__text").find(".heading").text("Your cart");

    // Enavi Side Cart | Expected Delivery AB test //
    function getExpectedDelivery() {
      const nowInBST = new Date(
        new Date().toLocaleString("en-US", { timeZone: "Europe/London" })
      );

      const startDate = new Date(nowInBST);
      startDate.setDate(startDate.getDate() + 3);

      const endDate = new Date(nowInBST);
      endDate.setDate(endDate.getDate() + 5);

      const formatDate = (date) => {
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${month}/${day}`;
      };

      const deliveryRange = `${formatDate(startDate)} - ${formatDate(endDate)}`;
      return deliveryRange;
    }
    try {
      document.querySelector(".delivery-timing").textContent =
        getExpectedDelivery();
    } catch (err) {}
    // Enavi Side Cart | Expected Delivery AB test //
  } else {
    $cartContainer.classList.add("empty__cart");
    $cartIcon.classList.add("empty__cart");
    $(".custom-cart-drawer--header__text")
      .find(".heading")
      .text("Your cart is empty");
  }

  $bubble.textContent = cart.item_count;
  $itemCount.textContent = `Subtotal (${cart.item_count} items)`;
  if (cart.original_total_price > cart.total_price) {
    $subtotal.innerHTML = `<del id="old_pricee" class="old_pricee">${formatCurrency(
      cart.original_total_price
    )}</del><span class="cart_totalll">${formatCurrency(
      cart.total_price
    )}</span>`;
    $subtotal.classList.add("text-red");
    $subtotal.setAttribute(
      "data-originalPrice",
      formatCurrency(cart.original_total_price)
    );
    $subtotalHelp.innerHTML = $subtotal.getAttribute("data-originalPrice");
    checkClass();
  } else {
    $subtotal.innerHTML = formatCurrency(cart.total_price);
    $subtotal.classList.remove("text-red");
  }
  $cartBody.classList.remove("cart__loading");
}
function initCart() {
  //debugger
  $.ajax({
    url: "/cart.js",
    dataType: "json",
    cache: false,
    success: function (cart) {
      refreshCart(cart);
    },
  });
}

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      this.cart =
          document.querySelector("cart-drawer") ||
          document.querySelector("cart-notification");
        this.submitButton = this.querySelector('[type="submit"]');
 this.submitButton.style.background = "#FFF";
            this.submitButton.style.borderColor = "#000";
            this.submitButton.style.color = "#000";        
if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
       
    // Change button styles
this.submitButton.style.background = "rgba(87, 191, 110, 1)";
this.submitButton.style.borderColor = "rgba(87, 191, 110, 1)";
this.submitButton.style.color = "rgba(255, 255, 255, 1)";

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        //debugger
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
           this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
                 console.log("Button disabled");

            // Change button styles
            this.submitButton.style.background = "rgba(87, 191, 110, 1)";
            this.submitButton.style.borderColor = "rgba(87, 191, 110, 1)";
            this.submitButton.style.color = "rgba(255, 255, 255, 1)";
            const addToCartText = this.submitButton.querySelector(".addto-cart");
            const tickIcon = this.submitButton.querySelector(".tick-icon");
            
            if (addToCartText) {
                addToCartText.style.display = "none"; // Hide text
            }
            
            if (tickIcon) {
                tickIcon.style.display = "inline-block"; // Show tick icon
            }
            initCart();
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
